module.exports = __webpack_public_path__ + "static/media/google-gray.c380dbe0.svg";